<app-page>
  <update-profile [loggedInUser]="globalVars.loggedInUser"></update-profile>
</app-page>
